export default "__VITE_ASSET__BY_ylENW__"